import { Outlet, useLocation } from 'react-router';
import { chatbots } from '@data/chatbots.js';
import { getAssetImageUrl } from '@util/common.js';
import { useMetaTags } from 'react-metatags-hook';
import { defaultOpenGraphImage, isTestMode } from '@util/const.js';
import PageHeader from '@components/layout/page-header.jsx';

export default function ChatbotPageLayout() {
  const location = useLocation();
  const page = location.pathname.split('chatbots/')[1].split('/')[0];

  const { name, description, shortDescription, images } = chatbots[page];

  const links = [{ title: 'Chatbots', href: `/chatbots` }, { title: name }];
  let metaImage;

  if (images && images.length > 0) metaImage = getAssetImageUrl(images[0]);
  else metaImage = defaultOpenGraphImage;

  useMetaTags(
    {
      title: `${name} | ${isTestMode ? '' : 'St. Jude '}Play Live Tools`,
      description: description || shortDescription,
      openGraph: {
        image: metaImage,
        description: description || shortDescription,
      },
    },
    [name, description, shortDescription, metaImage]
  );

  return (
    <div className="max-w-full relative flex flex-col items-center">
      <div className={`hero w-full pt-5 overflow-x-hidden`}>
        <div className="hero-content w-full overflow-x-hidden flex-col items-start">
          <div>
            <PageHeader name={name} links={links} />
          </div>

          <div className="overflow-x-hidden w-full mb-4">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
}
